import React, { useEffect, useState } from 'react'
import { classNames } from 'utils';

/**
 * Paginación.
 * @ignore
 * @param {object} props
 * @param {number} props.totalRecords
 * @param {number} props.rowsPerPage
 * @param {Array<number>|undefined} props.rowsPerPageOptions
 * @param {Function|undefined} props.onPage
 * @param {string|undefined} props.className
 * @param {React.CSSProperties|undefined} props.style 
 * @returns {JSX.Element} Retorna el componente Pagination.
 */
function Pagination({
  totalRecords=0, 
  rowsPerPage, 
  page, 
  rowsPerPageOptions, 
  onPage, 
  paginationReport,
  className, 
  style,
}) {
  const pageSize = parseInt(rowsPerPage)||10
  const currentPage = parseInt(page)||1
  const totalPages = pageSize>0 ? Math.ceil(totalRecords/pageSize)||1 : 1
  const [pages, setPages] = useState([])

  const pageSizeOptions = rowsPerPageOptions && (
    <div className='dropdown page-size-options'>
        <button className='btn dropdown-toggle py-1' type='button' data-bs-toggle='dropdown'>
            <span>{pageSize}</span>
        </button>
        <ul className='dropdown-menu'>
            {rowsPerPageOptions.map(size => (
                <li key={size} className='dropdown-item' onClick={() => handlePage(currentPage, size)}>{size}</li>
            ))}
        </ul>
    </div>
  )

  /** 
   * @param {number} page 
   * @param {number} pageSize
   */
  const handlePage = (page, _pageSize) => {
      onPage(page, _pageSize||pageSize)
  }

  const getPaginationData = () => {
    let data = []
    let ini = currentPage-2
    let end = currentPage+2
    if (ini < 1) {
        end += (1-ini)
        ini = 1
    }
    if (end > totalPages) {
        end = totalPages
        if (end-ini<4) {
            const __ini = totalPages-4
            ini = __ini<1?1:__ini
        }
    }
    for (let i = ini; i <= end; i++) {
        data.push({
            number: i,
            active: currentPage === i,
            onClick: currentPage === i ? ()=>{} : ()=>handlePage(i)
        })
    }
    setPages(data)
  }

  useEffect(()=>{
      getPaginationData()
  }, [totalRecords, rowsPerPage, page]) 

  const infoPagination = typeof paginationReport === 'string'
    ? (<div className='text-end py-1' style={{fontSize: '.75rem'}}>
        {paginationReport
            .replace('{totalRecords}', totalRecords)
            .replace('{totalPages}', totalPages)
            .replace('{rows}', rowsPerPage)
            .replace('{currentPage}', currentPage)}
    </div>)
    : (<div className='text-end py-1' style={{fontSize: '.75rem'}}>
        {`Nro. Registros: ${totalRecords} - Nro. Páginas: ${totalPages}`}
    </div>)

    return (
        <div className='bs-pagination'>
            {infoPagination}
            <div className={classNames(['pagination-pages', className])} style={style}>
                <button 
                    className='btn btn-pagination'
                    title='Primero'
                    {...(currentPage>1 ? {onClick:()=>handlePage(1)} : {disabled: true})}
                >
                    <span style={{letterSpacing: '-5px'}}>{'<<'}</span>
                </button>
                <button 
                    className='btn btn-pagination'
                    title='Anterior'
                    {...(currentPage-1>0 ? {onClick: ()=>handlePage(currentPage-1)} : {disabled: true})}
                >
                    <span>{'<'}</span>
                </button>
                {
                    currentPage > 0 
                        ? pages.map((page)=>(
                            <button 
                                key={page.number}
                                className={classNames(['btn btn-pagination', page.active&&'active'])}
                                onClick={page.onClick}
                            >
                                {page.number}
                            </button>
                        ))
                        : <button className='btn btn-pagination' disabled>0</button>
                }
                <button 
                    className='btn btn-pagination'
                    title='Siguiente'
                    {...(currentPage+1<=totalPages ? {onClick: ()=>handlePage(currentPage+1)} : {disabled: true})}
                >
                    <span>{'>'}</span>
                </button>
                <button 
                    className='btn btn-pagination'
                    title='Ultimo'
                    {...(currentPage<totalPages ? {onClick: ()=>handlePage(totalPages)} : {disabled: true})}
                >
                    <span style={{letterSpacing: '-5px'}}>{'>>'}</span>
                </button>
            </div>
            <div className='pagination-page-size'>
                <span className='me-2'>Items por página:</span>
                {rowsPerPageOptions ? pageSizeOptions : pageSize}
            </div>
        </div>
    )
}

export default Pagination;